/**
 * Check if a value is "empty"
 *
 * @param {*} value
 * @return {boolean}
 */
export function isEmpty(value) {
    return (value === undefined || value === null || value === '' || value === false);
}
/**
 * Check if a month is within the min/max number of months
 *
 * @param {number} month
 * @return {boolean}
 */
export function validMonth(month) {
    return month > 0 && month <= 12;
}
/**
 * Check if the day is within the min/max days
 * of the month/year combination
 *
 * @param {number} year
 * @param {number} month
 * @param {number} day
 * @return {boolean}
 */
export function validDay(year, month, day) {
    if (!validMonth(month)) {
        return false;
    }
    const maxDays = new Date(year, month, 0).getDate();
    return day > 0 && day <= maxDays;
}
/**
 * Left pad numbers depending on the pad parameter e.g.
 * 12 - "0012"
 * 1 - "01"
 *
 * @param {string} pad The padding of the string e.g.:
 *                     "00" which will prepend a zero on a single digit number - "01"
 * @param {number|string} number The number that we want to pad
 * @return {string}
 */
export const leftPadNumber = (pad, num) => {
    const strNumber = num.toString();
    return pad.substring(0, pad.length - strNumber.length) + strNumber;
};
/**
 * Make all the property names of an object lower case
 * User-Agent - user-agent
 * PropertyName - propertyname
 *
 * @param {Object} obj the object that we want to lower case the property names
 * @return {Object}
 */
export const lowerCasePropertyNames = (obj) => Object.entries(obj).reduce((acc, [key, value]) => {
    acc[key.toLowerCase()] = value;
    return acc;
}, {});
